// Keys a table cell owns itself — everything else on a cell comes from its column.
const TABLE_CELL_OWN_KEYS = ['value', 'filledByRole'];

// A row's cells are copies of the table's columns carrying the value entered in
// that cell. The column is the source of truth for a cell's settings: merging the
// column into the old cell would only overwrite the keys the column still has, so
// a setting removed from the column (a cleared default option, for instance) would
// stay alive on every row and be read back when the form is rendered. Rebuild each
// cell from its column and carry over only what the cell owns.
export const syncRowColsWithTableCols = (rowCols, tableCols) => {
  const currentRowCols = Array.isArray(rowCols) ? rowCols : [];

  return tableCols.map((tableCol, tableColIndex) => {
    const rowCol = currentRowCols.find((tempRowCol) => tempRowCol?.id === tableCol.id) || currentRowCols[tableColIndex];
    const newRowCol = { ...tableCol };

    if (rowCol) {
      TABLE_CELL_OWN_KEYS.forEach((key) => {
        if (key in rowCol) {
          newRowCol[key] = rowCol[key];
        }
      });
    }

    return newRowCol;
  });
};
